export default __webpack_public_path__ + "static/slide5-304e7802b3b31e2ef8f8a4ccf2a4bcc7.jpg";